<template>
  <section v-if="displayReceivedOrderSection(order)">
    <div v-if="!includeCssClass">
      <hr>
    </div>
    <div :class="{'card panel-white': includeCssClass}">
      <div :class="{'card-body': includeCssClass}">
        <strong>{{ $t('message.received_order.section_title') }}</strong>
        <div class="mt-2">
          {{ $t('message.received_order.section_title2') }}
        </div>
        <div class="row no-gutters mt-3">
          <div class="col-6 pr-2">
            <button class="btn h-100 btn-outline-info btn-block"
                    @click="openReportModal(order)">
              {{ $t('message.button.report_problem') }}
            </button>
          </div>
          <div class="col-6 pl-2">
            <button class="btn h-100 btn-info btn-block"
                    @click="openReceivedOrderModal(-1, order.id)">
              {{ $t('message.button.received_order') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Report an issue Modal -->
    <report-modal ref="reportModal"/>
    <!-- Received Order Modal -->
    <received-order-modal ref="receivedOrderModal"/>
  </section>
</template>

<script>
  import ReceivedOrderModal from './ReceivedOrderModal'
  import ReportModal from './ReportIssueModal'

  export default {
    props: {
      order: Object,
      includeCssClass: {
        type: Boolean,
        default: true
      }
    },
    components: {
      ReceivedOrderModal,
      ReportModal
    },
    methods: {
      displayReceivedOrderSection (order) {
        return (order.status === 2 && order.cancel === 0 && !order.is_received_order && order.order_report_issue === null)
      },
      openReportModal (order) {
        this.$refs.reportModal.setOrderData(order)
        this.$refs.reportModal.showReportIssueModal(true)
      },
      openReceivedOrderModal (index, orderId) {
        this.$refs.receivedOrderModal.setOrderData(index, orderId)
        this.$refs.receivedOrderModal.showReceivedOrderModal(true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ReceivedOrderSection.vue